<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <!-- Card stats -->
      <b-row
        v-if="listGroups && listGroups.grupos && listGroups.grupos.length > 0"
      >
        <template v-for="(item, index) in listGroups.grupos">
          <b-col @click="getGroupData(item)">
            <stats-card
              :title="item.nombre_grupo"
              type="gradient-red"
              :catecumenos="item.catecumenos_count"
              class="mb-4"
              :index="index"
              :backGround="item.backGround"
              :responsable="nombreCatequistas(item.catequistas)"
            >
            </stats-card>
          </b-col>
        </template>
      </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <tabla-catecumenos
            v-if="dataGroup != undefined"
            :cabecera="true"
            :editable="false"
            :datos="dataGroup"
            @guardaAsistencia="guardaDatosAsistencia"
            :listas="true"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import tablaCatecumenos from "@/components/Tables/TablaCatecumenos.vue";
import axios from "@/directives/axios.js";
import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  components: {
    tablaCatecumenos,
  },
  data() {
    return {
      listGroups: undefined,
      dataGroup: undefined,
    };
  },
  methods: {
    nombreCatequistas(value) {
      if (Array.isArray(value) && value.length > 0) {
        return value.map((element) => {
          return {
            nombre:
              element.nombre +
              " " +
              element.apellido1 +
              " " +
              element.apellido2,
            id: element.id,
          };
        });
      } else {
        return [];
      }
    },
    guardaDatosAsistencia(id, data) {
      loader.open();
      axios({
        method: "post",
        url: `/gestionCatequesis/asistencia`,
        withCredentials: true,
        data: {
          id: id,
          asistencia: data,
        },
      })
        .then((response) => {
          this.$store.dispatch("cargarCursosGruposCatequistas", response.data);
          this.$nextTick(() => {
            this.getInitialData();
            loader.close();
          });
        })
        .catch(() => {
          loader.close();
        });
    },
    getInitialData() {
      let id = this.$route.query.id;
      if (this.$store.getters.getCursosGruposNum != undefined) {
        this.listGroups = this.$store.getters.getCursosGruposNum.find(
          (element) => element.id == id
        );
        if (this.$store.getters.getCursosGruposCatequistas != undefined) {
          let data = this.$store.getters.getCursosGruposCatequistas.find(
            (element) => element.id == this.listGroups.id
          ).grupos;
          this.listGroups.grupos.forEach((element) => {
            data.forEach((element2) => {
              if (element.id == element2.id) {
                element.responsables = element2.catequistas;
                element.asistencia = element2.asistencia;
              }
            });
          });
        }
      } else {
        this.$router.push({
          name: "dashboard",
        });
      }
    },
    getGroupData(item) {
      this.dataGroup = item;
    },
  },
  computed: {},
  created() {
    this.getInitialData();
  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #172b4d;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #172b4d;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
